<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from 'moment'

export default {
  name: 'BroadcastListPage',
  data () {
    return {
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/broadcast/summary/' + item.id}>Summary</b-dropdown-item>
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'createdDate',
          columnName: 'Created Date',
          align: 'left',
          value: item => {
            return item.createdDate ? moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          columnCode: 'statusCode',
          columnName: 'Status',
          align: 'left',
          value: item => {
            return item.statusCode
          }
        },
        {
          columnCode: 'typeCode',
          columnName: 'Type',
          align: 'left',
          value: item => {
            return item.typeCode
          }
        },
        {
          columnCode: 'activeCount',
          columnName: 'Active Count',
          align: 'left',
          value: item => {
            return item.activeCount
          }
        },
        {
          columnCode: 'inactiveCount',
          columnName: 'Inactive Count',
          align: 'left',
          value: item => {
            return item.inactiveCount
          }
        },
        {
          columnCode: 'createdByUserName',
          columnName: 'Tg UserName',
          align: 'left',
          value: item => {
            return item.createdByUserName
          }
        },
        {
          columnCode: 'member',
          columnName: 'User',
          align: 'left',
          value: item => {
            return item.member ? item.member.name : ''
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('broadcast/list', payload)
    },
    addNewButton () {
      return (<router-link class="btn btn-success mr-3" to="/broadcast/add"><div class="icon-plus"></div></router-link>)
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/broadcast/BroadcastListPage.vue